module.exports = __webpack_public_path__ + "static/img/user_3.7e91d4a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/user_3.png
// module id = xaAU
// module chunks = 0